import { render, staticRenderFns } from "./navTop.vue?vue&type=template&id=56cfff5a&scoped=true&"
import script from "./navTop.vue?vue&type=script&lang=js&"
export * from "./navTop.vue?vue&type=script&lang=js&"
import style0 from "./navTop.vue?vue&type=style&index=0&id=56cfff5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cfff5a",
  null
  
)

export default component.exports